import { Parallax } from 'react-scroll-parallax';

import ParallaxContainer from '../../../../components/Parallax/ParallaxContainer';

import MainLabel from './MainLabel/MainLabel';
import SlotLoversSection from './SlotLoversSection/SlotLoversSection';
import TopBannerPromos from './TopBannerPromos/TopBannerPromos';
import {
  FreeSpinsDeskParallax,
  FreeSpinsMobParallax,
} from './TopBannerSection.constants';
import styles from './TopBannerSection.module.css';
import { Breakpoint, useBreakpoint, Image } from '@betty/moonlight';

function TopBannerSection() {
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === Breakpoint.MOBILE;

  return (
    <div className={styles.promoBannerWrap}>
      <div className={styles.parallaxContainer}>
        <ParallaxContainer>
          {(isMobile ? FreeSpinsMobParallax : FreeSpinsDeskParallax).map(
            (coin, index) => (
              <Parallax key={index} speed={coin.speed}>
                <div className={styles.coinWrap}>
                  <Image name={coin.image} width="100%" height="100%" />
                </div>
              </Parallax>
            ),
          )}
        </ParallaxContainer>
      </div>
      <div className={styles.mainWrapper}>
        <span className={styles.heroImageWrapper}>
          <Image
            name={
              isMobile
                ? 'landingPage.topBannerImageMobile'
                : 'landingPage.topBannerImageDesktop'
            }
            width="100%"
            height={{
              desktop: 550,
              tablet: 350,
              mobile: 350,
            }}
            contentFit="cover"
            alt="heroBanner"
            priority="high"
            objectPosition="top"
          />
        </span>
        <SlotLoversSection />
        <MainLabel />
      </div>
      <TopBannerPromos />
    </div>
  );
}

export default TopBannerSection;
